import React from 'react';

// Color themes for different portals
const themes = {
  user: {
    primary: '#3B82F6', // Blue 500
    secondary: '#8B5CF6', // Purple 500
    tertiary: '#6366F1', // Indigo 500
    bg: '#1E40AF'
  },
  admin: {
    primary: '#F43F5E', // Rose 500
    secondary: '#FB7185', // Rose 400
    tertiary: '#FDA4AF', // Rose 300
    bg: '#881337'
  },
  nominee: {
    primary: '#14B8A6', // Teal 500
    secondary: '#06B6D4', // Cyan 500
    tertiary: '#2DD4BF', // Teal 400
    bg: '#0F766E'
  }
};

const FuturisticLoader = ({ message = "Loading...", theme = "user" }) => {
  const colors = themes[theme] || themes.user;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0a0a0f',
        overflow: 'hidden',
        contain: 'strict',
        willChange: 'transform'
      }}
    >
      <div style={{ textAlign: 'center', willChange: 'transform', transform: 'translateZ(0)' }}>
        {/* Animated ring loader */}
        <div style={{ position: 'relative', width: 128, height: 128, margin: '0 auto 24px' }}>
          {/* Outer ring */}
          <div
            className="animate-spin"
            style={{
              position: 'absolute',
              inset: 0,
              borderRadius: '50%',
              border: '4px solid transparent',
              borderTopColor: colors.primary,
              borderRightColor: colors.primary,
              willChange: 'transform'
            }}
          />

          {/* Middle ring */}
          <div
            className="animate-spin-slow"
            style={{
              position: 'absolute',
              inset: 8,
              borderRadius: '50%',
              border: '4px solid transparent',
              borderBottomColor: colors.secondary,
              borderLeftColor: colors.secondary,
              willChange: 'transform'
            }}
          />

          {/* Inner ring */}
          <div
            className="animate-spin-reverse"
            style={{
              position: 'absolute',
              inset: 16,
              borderRadius: '50%',
              border: '4px solid transparent',
              borderTopColor: colors.tertiary,
              borderRightColor: colors.tertiary,
              willChange: 'transform'
            }}
          />

          {/* Center glow */}
          <div
            className="animate-pulse"
            style={{
              position: 'absolute',
              inset: 32,
              borderRadius: '50%',
              backgroundColor: `${colors.bg}33`,
              willChange: 'opacity'
            }}
          />

          {/* Center dot */}
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div
              className="animate-ping"
              style={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: colors.primary,
                boxShadow: `0 0 10px ${colors.primary}80`,
                willChange: 'transform, opacity'
              }}
            />
            <div
              style={{
                position: 'absolute',
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: colors.primary
              }}
            />
          </div>
        </div>

        {/* Loading text */}
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)',
          display: 'inline-block',
          padding: '16px 32px',
          borderRadius: 16
        }}>
          <p style={{ fontSize: 18, fontWeight: 600, color: 'white', marginBottom: 8 }}>{message}</p>
          <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: colors.primary,
                  display: 'inline-block',
                  animation: 'loaderDotBounce 1s ease-in-out infinite',
                  animationDelay: `${i * 150}ms`,
                  willChange: 'transform'
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* CSS for dot animation using transform (no layout shift) */}
      <style>{`
        @keyframes loaderDotBounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-6px); }
        }
      `}</style>
    </div>
  );
};

export default FuturisticLoader;
